<template>
  <div class="title-base">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
      <el-breadcrumb-item :to="FirstUrl">{{FirstBread}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="SecondUrl">{{SecondBread}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="ThirdBread">{{ThirdBread}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="title-content">
      <span>{{TitleName}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserDetailTitle",
    props:{
      TitleName:{},
      FirstBread:{},
      FirstUrl:{},
      SecondBread:{},
      SecondUrl:{},
      ThirdBread:{}
    },
    methods:{
      HandleFirst(){
        console.log('11');
        this.$router.push(this.FirstUrl)
      },
      HandleSecond(){
        console.log('22');
        if(this.ThirdBread){
          this.$router.push(this.SecondUrl)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .title-base{
    padding-left: 10px;
    padding-top: 10px;
    .title-content{
      border-left: 4px solid #188ACB;
      border-radius: 1px;
      margin-top: 20px;
      height: 15px;
      position: relative;
      span{
        display: block;
        position: absolute;
        height: 18px;
        top: -6px;
        left: 5px;
        font-size: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 27px;
      }
    }
  }
</style>